import Swiper from 'swiper';

export default sliderRooms => {
    //console.log('sliderRooms');
    const swiperContainer = sliderRooms.querySelector('.swiper-container');
    const swiperPagination = sliderRooms.querySelector('.swiper-pagination');
    const swiperButtonPrev = sliderRooms.querySelector('.swiper-button-prev');
    const swiperButtonNext = sliderRooms.querySelector('.swiper-button-next');

    const roomsSlider = new Swiper(swiperContainer, {
        init: false,
        slidesPerView: 1,
        loop: true,
        spaceBetween: 30,
        grabCursor: true,
        pagination: {
            el: swiperPagination,
            clickable: true,
            renderBullet: (index, className) => `<button type="button" class="${className}"><span class="sr-only">${index + 1}</span></button>`,
        },
        navigation: {
            prevEl: swiperButtonPrev,
            nextEl: swiperButtonNext,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
        }
    });

    roomsSlider.init();
};
